<script lang="ts">
	import { cn } from '$lib/shadcn/utils.js';
	import { DropdownMenu as DropdownMenuPrimitive } from 'bits-ui';
	import { tv, type VariantProps } from 'tailwind-variants';

	let {
		ref = $bindable(null),
		class: className,
		inset,
		variant = 'default',
		size = 'default',
		...restProps
	}: DropdownMenuPrimitive.ItemProps & {
		inset?: boolean;
		variant?: VariantProps<typeof itemVariants>['variant'];
		size?: VariantProps<typeof itemVariants>['size'];
	} = $props();

	export const itemVariants = tv({
		base: "relative flex cursor-pointer items-center gap-2 rounded-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:ps-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
		variants: {
			variant: {
				default:
					"data-highlighted:bg-accent data-highlighted:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground ",
				destructive:
					'text-destructive data-highlighted:bg-destructive/10 dark:data-highlighted:bg-destructive/20 data-highlighted:text-destructive *:[svg]:!text-destructive ',
				filled:
					"data-highlighted:bg-muted-foreground data-highlighted:text-muted [&_svg:not([class*='text-'])]:text-muted-foreground ",
				tonal: 'preset-tonal hover:bg-foreground/2.5 hover:text-foreground/70',
				ghost: 'hover:bg-foreground hover:text-accent-foreground dark:hover:bg-foreground/50',
				'ghost-destructive': 'hover:text-destructive',
				ghost2: 'hover:opacity-60',
				ghost3: 'hover:bg-foreground/20 hover:text-foreground'
			},
			size: {
				default: 'px-2 py-1.5 text-sm',
				sm: 'h-6 gap-1.5 px-3 has-[>svg]:px-2.5 text-sm'
			}
		},
		defaultVariants: {
			variant: 'default',
			size: 'default'
		}
	});
</script>

<DropdownMenuPrimitive.Item
	bind:ref
	data-slot="dropdown-menu-item"
	data-inset={inset}
	data-variant={variant}
	class={cn(itemVariants({ variant, size }), className)}
	{...restProps}
/>
